export default "__VITE_ASSET__a45a1e41__"